import React from 'react';
import PropTypes from 'prop-types';
// Core components
import AppLoader from 'components/core/AppLoader';
// Permissions
import OnlyWith from 'components/permissions/OnlyWith';
// Custom
import { CreateTextButton } from 'components/buttons/TextButtons';
import { permissionsShape } from 'constants/PropTypesShapes';
import ResourcesSelectField from './ResourcesSelectField';

const ResourcesSelectFieldWithCreateButton = ({
  loading,
  infoButton,
  selectFieldProps,
  addPermissions,
  onAddResource,
}) => (
  <div className="row align-items-center">
    <div className="col-12 col-lg-8 d-flex align-items-baseline">
      {loading ? (
        <div className="pt-4">
          <AppLoader size={24} />
        </div>
      ) : (
        <ResourcesSelectField {...selectFieldProps} />
      )}
      {infoButton}
    </div>
    <OnlyWith permissions={addPermissions}>
      <div className="col-12 col-lg-4 d-flex justify-content-end pt-lg-4">
        <CreateTextButton
          size="small"
          onClick={onAddResource}
        />
      </div>
    </OnlyWith>
  </div>
);

ResourcesSelectFieldWithCreateButton.propTypes = {
  loading: PropTypes.bool.isRequired,
  infoButton: PropTypes.node,
  selectFieldProps: PropTypes.object.isRequired,
  addPermissions: permissionsShape,
  onAddResource: PropTypes.func.isRequired,
};

ResourcesSelectFieldWithCreateButton.defaultProps = {
  infoButton: null,
  addPermissions: null,
};

module.exports = ResourcesSelectFieldWithCreateButton;



// WEBPACK FOOTER //
// ./components/inputFields/ResourcesSelectFieldWithCreateButton.js